import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const Logout = props => (
  <SvgIcon viewBox="0 0 16.384 16.384" {...props}>
    <path id="Path_2556" data-name="Path 2556" d="M10.24,14.336H2.048V2.048H10.24V3.072h2.048V0H0V16.384H12.288V13.312H10.24v1.024Z" />
    <path id="Path_2557" data-name="Path 2557" d="M230.975,138.329l-1.448,1.448,1.324,1.324h-5.3v2.048h5.3l-1.324,1.324,1.448,1.448,3.8-3.8Z" transform="translate(-218.387 -133.933)" />
  </SvgIcon>
);

export default Logout;
